import { React, useEffect, useRef, useState } from 'react'
import styles from './VideoHelp.module.scss'

const VideoHelp = (props) => {
  const toSeconds = (timeStr) => {
    const [min, sec] = timeStr.split(':').map(Number)
    return min * 60 + sec
  }
  const videoRef = useRef(null)
  const [activeSegment, setActiveSegment] = useState(null)
  const [activeButton, setActiveButton] = useState(null) // Added state for active button
  const segments = [
    { label: 'What TalkPro does', start: '0:00', end: '0:30' },
    { label: 'How is it different from Zoom?', start: '0:34', end: '1:03' },
    { label: 'Privacy and security', start: '1:05', end: '1:33' },
    { label: 'How do summaries work?', start: '1:35', end: '1:57' },
    { label: 'The Google integration', start: '1:59', end: '2:23' },
    { label: 'Getting paid for calls', start: '2:26', end: '2:52' },
    { label: 'Tell me more AI Action items', start: '2:54', end: '3:18' },
  ]
  const handlePlaySegment = (segment) => {
    if (videoRef.current) {
      const start = toSeconds(segment.start)
      const end = toSeconds(segment.end)
      videoRef.current.currentTime = start
      videoRef.current.play()
      setActiveSegment({ start, end })
      setActiveButton(segment.label) // Set active button
    }
  }
  useEffect(() => {
    const video = videoRef.current
    if (!video || !activeSegment) return
    const checkTime = () => {
      if (video.currentTime >= activeSegment.end) {
        video.pause()
        setActiveSegment(null)
        setActiveButton(null) // Clear active button
      }
    }
    video.addEventListener('timeupdate', checkTime)
    return () => video.removeEventListener('timeupdate', checkTime)
  }, [activeSegment])
  return (
    <div className={styles.Videocontainer}>
      <div className={styles.VideoHelpH1}>Welcome</div>
      <div className={styles.VideoHelpH2}>
        Please choose of the following topics you would like some tips for or questions.
      </div>
      <div>
        {segments.map((segment) => (
          <button
            key={segment.label}
            onClick={() => handlePlaySegment(segment)}
            className={`${styles.VideoButton} ${
              activeButton === segment.label ? styles.Active : ''
            }`}
          >
            {segment.label}
          </button>
        ))}
      </div>
      <video ref={videoRef} className={styles.Videostyle}>
        <source
          src="https://join.talkpro.com/wp-content/uploads/2025/06/TP_What_is_Talkpro2_V5-compressed.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
    </div>
  )
}
export default VideoHelp
